module.exports = __webpack_public_path__ + "static/media/m_eyeshape_round_brown.9046bfae.png";